// Module
var code = "<input class=form-control ng-model=$ctrl.model placeholder=\"{{'Anytime' | translate }}\" ng-change=$ctrl.onChange() /> ";
// Exports
module.exports = code;